// src/services/commentService.js
import api from '../api/api';

const getCommentsByVideo = async (videoId) => {
  try {
    // Use the non-admin endpoint for enrolled user access
    const response = await api.get(`/comments/video/${videoId}`);
    return response.data; // Expects ApiResponse<List<CommentResponse>>
  } catch (error) {
    // Return a default error structure consistent with ApiResponse
    return { success: false, message: error.response?.data?.message || 'Failed to fetch comments.', data: [] };
  }
};

const createComment = async (videoId, text) => {
  try {
    const response = await api.post('/comments', { videoId, text });
    return response.data; // Expects ApiResponse<CommentResponse>
  } catch (error) {
    // Return a default error structure consistent with ApiResponse
    return { success: false, message: error.response?.data?.message || 'Failed to post comment.' };
  }
};

const commentService = {
  getCommentsByVideo,
  createComment,
};

export default commentService;